<div fxLayout="column" fxLayoutAlign="center center" class="dialog-container pr-24 pl-24 pb-48 pt-48 w-100">
    <div class="h3-semi-bold c-primary-gray-900 text-center pre-line">
        {{ 'i18n_af_importFraudDialogTitleImportFile' | translate }}
    </div>
    @if (subtitle) {
        <div class="mt-16 t3 c-primary-gray-600 text-center pre-line">
            {{ subtitle | translate }}
        </div>
    }
    <a (click)="downloadTemplate()" class="t3 underlined-text">{{ 'i18n_af_downloadTemplate' | translate }}</a>
    @if (!fileData) {
        <ngx-dropzone class="drop-zone w-100 mt-24"
                      accept="application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv"
                      [multiple]="false"
                      [class.drop-zone-error]="fileError"
                      (change)="onFileSelected($event)">
            <ngx-dropzone-label>
                <div fxLayout="column" fxLayoutAlign="center center" class="h-100">
                    @switch (fileError) {
                        @default {
                            <div fxLayout="row" fxLayoutAlign="center center">
                                @if (!Spinner.isShown('fileReading')) {
                                    <ui-kit-svg class="i-24" name="ic_attach"></ui-kit-svg>
                                    <div class="c-primary-green-800 ml-8 t-button">{{ 'i18n_af_attachFileTitle' | translate }}</div>
                                }
                                <ui-kit-spinner spinnerIds="fileReading"></ui-kit-spinner>
                            </div>
                        }
                        @case ('WRONG_FORMAT') {
                            <div
                                class="c-secondary-red-900 t-button">{{ 'i18n_af_errorWrongFileFormat' | translate }}
                            </div>
                        }
                    }
                </div>
            </ngx-dropzone-label>
        </ngx-dropzone>
        <div class="t3 c-primary-gray-600 mt-4" fxFlexAlign="start">{{ 'i18n_af_dropzoneDescriptionFileLimit' | translate }}</div>
    }
    @if (fileData) {
        <div class="document mt-24 w-100"
             (mouseenter)="fileData.hover=true" (mouseleave)="fileData.hover=false"
             fxFlex fxLayout="column">
            <div fxLayout="row" fxLayoutAlign="center center" class="w-100 h-100">
                <ui-kit-svg class="i-24 icon" name="ic_document"></ui-kit-svg>
                <div class="t4 ml-4 pr-8 text-ellipsis overflow-hidden" fxFlex>
                    {{ fileData.fileName }}
                </div>
                <div class="i-24" fxLayout="column">
                    @if (!fileData.completed || fileData.hover) {
                        <ui-kit-svg
                            class="i-24 pointer c-primary-gray-800"
                            (click)="fileData = null"
                            name="ic_cross">
                        </ui-kit-svg>
                    }
                    @if (fileData.completed && !fileData.hover) {
                        <ui-kit-svg
                            class="i-24 c-primary-green-600"
                            name="ic_checkmark_small">
                        </ui-kit-svg>
                    }
                </div>
            </div>
            @if (!fileData.completed) {
                <mat-progress-bar
                    class="w-100 progress hide-scroll-bar mt-12"
                    color="primary"
                    mode="determinate"
                    [value]="fileData.progressLoaded">
                </mat-progress-bar>
            }
        </div>
    }

    <ui-kit-button [label]="'i18n_af_buttonImport' | translate"
                   class="mt-32"
                   [disabled]='!fileData'
                   (clickListener)="submit()"
                   spinnerId="saving"/>

    <ui-kit-button [label]="'i18n_af_buttonCancel' | translate"
                   class="mt-16"
                   type="text"
                   (clickListener)="dialogRef.close()"/>
</div>
